import { Component } from '@angular/core';
import { OnboardingProvider } from '../../../providers/onboarding/onboarding';
import { UserProvider } from '../../../providers/user/user';
import { AuthProvider } from '../../../providers/auth/auth';

@Component({
  selector: 'preview-mode-header',
  templateUrl: 'preview-mode-header.html',
})
export class PreviewModeHeaderComponent {
  constructor(
    public onboarding: OnboardingProvider,
    public user: UserProvider,
    public auth: AuthProvider
  ) {}

  async closePreviewMode() {
    this.onboarding.startOnboarding('later');
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/components/preview-mode/preview-mode-header/preview-mode-header.ts